/* eslint-disable react-hooks/exhaustive-deps */
import { Box, Divider, IconButton, InputLabel, Typography, styled } from '@mui/material';
import InputController, { InputControllerWithIcon } from '../../../components/InputController/InputController';
import React, { useEffect, useRef, useState } from 'react'

import CustomDialog from '../../../components/CustomDialog/CustomDialog';
import CustomToast from '../../../components/Toast/CustomToast';
import DatePickerController from '../../../components/CustomDatepicker/CustomDatePicker';
import { ENDPOINT } from '../../../services/endPoints';
import EngineeringRoundedIcon from '@mui/icons-material/EngineeringRounded';
import FocusedHistory from './sub-form-sections/FocusedHistory';
import FootAmputation from './sub-form-sections/FootAmputation';
import FootAssesment from './sub-form-sections/FootAssesment';
import FootSummary from './sub-form-sections/FootSummary';
import FootWearWorn from './sub-form-sections/FootWearWorn';
import IdentifyingSection from '../DiabeticForm/sub-form-sections/IdentifyingSection';
import KnownPatientsFoot from './sub-form-sections/KnownPatientsFoot';
import NeurologicalStatus from './sub-form-sections/NeurologicalStatus';
import PrintIcon from '@mui/icons-material/Print';
import RadioButtonController from '../../../components/RadioButtonController/RadioButtonController';
import ReactToPrint from 'react-to-print';
import SkinAssesment from './sub-form-sections/SkinAssesment';
import VascularSupply from './sub-form-sections/VascularSupply';
import { facilityType } from '../DiabeticForm/sub-form-sections/formOptions';
import { useForm } from 'react-hook-form';
import useMasterApi from '../../../services/useMasterApi';
import useToast from '../../../hooks/useToast';
import FormFootPdf from './FootFormPdf/FormFootPdf';

export const ParentContainerSection = ({heading=false, children})=>{
  return (
    <>
      <Box sx={{ border: "1px solid", borderColor: "#DDDDDD", display: "flex", flexDirection: "column", gap: "1rem", borderRadius: "10px", mb: "0.5rem" }}>
        {heading && <Box sx={{ backgroundColor: "#F5F5F5", p: "0.5rem", borderRadius: "inherit" }}>
          <Typography variant="h6" sx={{ position: "relative", left: "10px", fontWeight: "bold" }}>{heading}</Typography>
        </Box>}
        <Box sx={{ width: "95%", margin: "0 auto",  }}>
          {children}
        </Box>
      </Box>
    </>
  );
};

export const CustomInputLable = styled(InputLabel)(({theme})=>({
  fontSize: "14px",
  textWrap: "wrap",
  fontWeight: "bold",
  color: "black",
  "& .MuiInputLabel-asterisk": {
    color: "red",
  },
}));

export const InputContainer = styled(Box)(({theme, width, fitcontent, minWidth})=>({
  display: "flex",
  alignItems: "center",
  flexDirection: "row",
  width: "100%",
  gap: "1rem",
  "& > label:first-of-type": {
    // maxWidth: minWidth ? minWidth : undefined,
    width: width ? width : fitcontent ? fitcontent : "20%",
  },
  [theme.breakpoints.down("lg")]:{
    "& > label:first-of-type": {
      //  maxWidth: minWidth ? minWidth : undefined,
      width:width ? width : fitcontent ? fitcontent : "15%",
    },
  },
  [theme.breakpoints.down("md")]:{
    flexDirection: "column",
    gap: "0.35rem",
    "& > label:first-of-type": {
      width: "100%",
    },
    "& > div:first-of-type": {
      width: "100%",
    },
  },

  marginBottom: "1rem"

}));



const FootForm = ({formData, rejected}) => {
  const hospitalId = localStorage.getItem("hospitalId");
  const componentRef = useRef();
  const { put: formViewed } = useMasterApi();
  const { put: statusUpdate, data} = useMasterApi();
  const { toastMessage, toast, toastType, setToast, showToast } = useToast()

  const { handleSubmit, setValue, getValues,watch, reset, control, formState: { errors } } = useForm({
    defaultValues:{

        facility_name:formData?.facility_name || "",
        facility_type: formData?.facility_type || "",
        form_filling_Date: formData?.form_filling_Date,
        // nurse_name: formData?.nurse_name || "",  // for Nurse Name

        patient_name: formData?.patient_name || "",
        patient_dob: formData?.patient_DOB || "",
        patient_gender: formData?.patient_gender || "",
        cmis_number: formData?.patient_cmis_id || "",

        focused_history:{
          presenting_complaint: formData?.focused_history_presenting_complaint || [],
          past_medical_history:formData?.focused_history_past_medical_history || [],
          on_treatment:formData?.focused_history_on_treatment || "",
          treatment_type:formData?.focused_history_treatment_type || [],
        },

        known_patients_foot:{
          duration: formData?.known_patients_foot_duration || "",
          type: formData?.known_patients_foot_type || [],
          current_medication: formData?.known_patients_foot_current_medication || "",
          known_patients_foot_medication_oral_injection : formData?.known_patients_foot_medication_oral_injection || [],
          blood_sugar_levelsfoot:formData?.known_patients_foot_blood_sugar_levelsfoot || "",
          blood_sugar_level:{
            RBS:formData?.known_patients_foot_blood_sugar_level?.RBS || "",
            FBS:formData?.known_patients_foot_blood_sugar_level?.FBS || "",
            HbA1c:formData?.known_patients_foot_blood_sugar_level?.HbA1c || ""
          },
          risk_factor_excercise_foot:formData?.known_patients_foot_risk_factor_excercise_foot || "",
          alochol_use_foot:formData?.known_patients_foot_alochol_use_foot || "",
          diet_foot:formData?.known_patients_foot_diet_foot || "",
          smoker_foot:formData?.known_patients_foot_smoker_foot || "",
        },


        footwear_often_worn:{
          footwear_often_worn: formData?.footwear_often_worn || [],
          frequency_footwear: formData?.frequency_footwear || "",
        },

        
        foot_assesment:{
            foot_assesment:formData?.foot_assesment || [],
            nail_infection:formData?.foot_assesment_nail_infection || [],
            orthopedic_motion:formData?.foot_assesment_orthopedic_motion || "",
        },

        skin_assesment:{
          temperature: formData?.skin_assesment_temperature || "",
          color: formData?.skin_assesment_color || "",
          infection: formData?.skin_assesment_infection || [],
          texture: formData?.skin_assesment_texture || "",
          moisture: formData?.skin_assesment_moisture || "",
          gradient: formData?.skin_assesment_gradient || "",
        },


        vascular_supply:{
            vPlulses_left_leg:{
                dorsalis_pedis:formData?.vPlulses_left_leg_dorsalis_pedis || "",
                anterior_tibial:formData?.vPlulses_left_leg_anterior_tibial || "",
                posterior_tibial:formData?.vPlulses_left_leg_posterior_tibial || "",
                popliteal:formData?.vPlulses_left_leg_popliteal || "",
            },
            vPulses_right_leg:{
                dorsalis_pedis:formData?.vPulses_right_leg_dorsalis_pedis || "",
                anterior_tibial:formData?.vPulses_right_leg_anterior_tibial || "",
                posterior_tibial:formData?.vPulses_right_leg_posterior_tibial || "",
                popliteal:formData?.vPulses_right_leg_popliteal || "",
            },

            vDoppler:formData?.vDoppler || "",

            left_leg:{
              dorsalis_pedis:formData?.dorsalis_pedis_left_leg || "",
              posterior_tibial:formData?.posterior_tibial_left_leg || "",
            },
            right_leg:{
              dorsalis_pedis:formData?.dorsalis_pedis_right_leg || "",
              posterior_tibial:formData?.posterior_tibial_right_leg || "",
            },

            vABPI:formData?.vABPI || [],
        },

        neurological_status:{
          neurological_left:{
            pain_sensation:formData?.neurological_left_pain_sensation || "",
            light_touch:formData?.neurological_left_light_touch || "",
            temperature:formData?.neurological_left_temperature_sensation || "",
            vibration_sensation:formData?.neurological_left_vibration_sensation || "",
          },
          neurological_right:{
            pain_sensation:formData?.neurological_right_pain_sensation || "",
            light_touch:formData?.neurological_right_light_touch || "",
            temperature:formData?.neurological_right_temperature_sensation || "",
            vibration_sensation:formData?.neurological_right_vibration_sensation || "",
          },
        },
        
        foot_sensation_diag_left_select: formData?.foot_sensation_diag_left_select || "",
        foot_sensation_diag_right_select: formData?.foot_sensation_diag_right_select || "",

          foot_sensation_diag_left: formData?.foot_sensation_diag_left  || [],

          foot_sensation_diag_right: formData?.foot_sensation_diag_right || [],

        foot_amputation:{
          amputation_left:formData?.amputation_left || [],
          amputation_right: formData?.amputation_right ||  [],
        },

        risk_rating:formData?.form_risk_rating || "",
        comments:  formData?.comments ||"",
        image1:  formData?.image1 || "",
        image2: formData?.image2 || "",
        image3: formData?.image3 || "",
        image4: formData?.image4 || "",

        clinic_name:formData?.hospital_Name,
        referral_site_name:formData?.hospital_Name || "",
    }
});

const onSubmit = async(data)=>{
    // console.log("dataValue", data)
}

useEffect(()=>{
  if(data.success){
    showToast("success", "Status Comment Added Successfully")
    rejected.setIsRejected(true);
  }else {
    rejected.setIsRejected(false);
  }
},[data])

useEffect(() => {
  if(formData!==undefined) {
    if ((Object.keys(formData).length) && formData?.form_viewed !== "1" && hospitalId === formData?.hospital_id) {
      formViewed(`${ENDPOINT.FORM_VIEWED}/${formData?.form_code}`, { form_viewed: "1", form_type: formData?.formType })
    }
  }
}, [formData]);


const onReject = (formCode, comment) => {
  statusUpdate(`${ENDPOINT.STATUS}/${formCode}`, { form_accept_reject: "2", doctore_comments1: comment, form_type: formData?.form_type });
}


  return (
    <>
      
      <div>
      <ReactToPrint
        trigger={() => <IconButton sx={{
            borderRadius: "2%", ":hover": {
              background: (theme) => theme.palette.secondary.main,
              borderRadius: "2%"
            }
          }}><strong>Print form</strong><PrintIcon />
          </IconButton>}
        content={() => componentRef.current}
      />
      <div style={{ display: "none" }}>
        <FormFootPdf ref={componentRef} formData={formData}/>
      </div>
    </div>
    
    <form onSubmit={handleSubmit(onSubmit)} style={{  padding: "1rem" }}>
     {(formData?.form_accept_reject || rejected.isRejected) && <Typography variant='h1' color="error" sx={{fontWeight:"bold", textAlign: "center"}}>This form has been rejected by the referred hospital</Typography> }
    <Box sx={{ display: "flex", alignItems: "center", width: "100%", justifyContent: "flex-end" }}>
          {hospitalId === formData?.hospital_id ? <CustomDialog isStatus={formData?.form_accept_reject || rejected.isRejected}  formCode={formData?.form_code} onReject={onReject} /> : null}
        </Box>
                    <Box sx={{  display:"flex", justifyContent:"center", flexDirection: "column", gap:"1rem", alignItems:"center", my:2, }}>
                              
                              <Box sx={{ display: "flex", gap: "0.5rem" }}>
                              <InputControllerWithIcon
                                    name="facility_name"
                                    label="Facility Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />  
                            {/* <InputControllerWithIcon
                                    name="facility_name"
                                    label="Nurse Name"
                                    control={control}
                                    errors={errors}
                                    isSmall={true}
                                    size="small"
                                    isDisabled={true}
                                    icon={<EngineeringRoundedIcon/>}
                            />    */}
                            </Box>

                            <Box sx={{ display: "flex", gap:"1rem", alignItems: "center", flexWrap: "wrap"}}> 
                            <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold"}}>Facility Type :</InputLabel>
                            <RadioButtonController
                                name="facility_type"
                                label="Facility Type"
                                control={control}
                                errors={errors}
                                options={facilityType}
                                isRow={true}
                                isDisabled={true}
                            />     
                            <DatePickerController name="form_filling_Date"
                             label="Test Date"
                              control={control}
                               errors={errors}
                                readOnly={true}
                                getValues={getValues}
                                 />
                            </Box>

                </Box>  
                               <Divider sx={{my:2}}/>
                    <Box >
                              <IdentifyingSection control={control} errors={errors}/>
                            </Box> 
                            <Divider sx={{my:2}}/>

                 <FocusedHistory control={control} errors={errors} watch={watch}/>
                 <KnownPatientsFoot control={control} errors={errors} watch={watch}/>

                 <FootWearWorn control={control} errors={errors}/>
                 <FootAssesment control={control} errors={errors}/>
                 <SkinAssesment control={control} errors={errors}/>
                 <VascularSupply control={control} errors={errors}/>
                 <NeurologicalStatus control={control} errors={errors} getValues={getValues} setValue={setValue}/>
                 <FootAmputation control={control} errors={errors}/>

                 <FootSummary control={control} errors={errors} getValues={getValues}/>

{/* <Box sx={{ display: "flex", justifyContent: "space-between", width:"100%", gap:"2rem", my:2}}>
   <Box sx={{ flex: "1 1 50%"}}>
     <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold", my:2}}>Clinic Name</InputLabel>
       <InputController
           name="clinic_name"
           label="Clinic Name"
           control={control}
           errors={errors}
           getValues={getValues}
           size="small"
           isDisabled={true}
        />
     </Box> 
   
</Box> */}


<Box sx={{ display: "flex", justifyContent: "space-between", width:"100%", gap:"2rem", my:2}}>
                      <Box sx={{ flex: "1 1 50%"}}>
                      <InputLabel sx={{ color: (theme)=>theme.palette.black.main, fontWeight:"bold", my:2}}>Referred Tertiary Healthcare Facility Name</InputLabel>
                        <InputController
                            name="referral_site_name"
                            label="Referred Tertiary Healthcare Facility Name"
                            control={control}
                            errors={errors}
                            getValues={getValues}
                            size="small"
                            isDisabled={true}
                         />
                      </Box> 
                 </Box>
    </form>
    {toast && <CustomToast 
        open={toast}
        toastMessage={toastMessage}
        setToast={setToast}
        toastType={toastType}
      />}
    </>
  )
}

export default FootForm